module.exports = __webpack_public_path__ + "static/img/banner@3x.6280718.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/QuestionHeader/images/banner@3x.png
// module id = UKkB
// module chunks = 1